export const LessonContentTypeEnumText = {
    Material: "Material",
    Plan: "Plan",
    Attachment: "Attachment"
}